// extracted by mini-css-extract-plugin
export default {"titleStyleMyletter":"MyExternalLetters_titleStyleMyletter__s1KzC"};